import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  retainRecordedCall,
  releaseRecordedCall,
} from "../../../../store/RecordedCalls/recordedCallsThunks";

import {
  Box,
  Button,
  FormControl,
  FormLabel,
  TextField,
  Typography,
  Stack,
} from "@mui/material";

const RetentionModalContent = ({ recordedCall, onClose }) => {
  const dispatch = useDispatch();
  const [reason, setReason] = useState("");
  const [error, setError] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(false);

    if (!reason.trim()) {
      setError(true);
      return;
    }

    setSubmitting(true);
    const thunk = recordedCall.retainPermanently
      ? releaseRecordedCall
      : retainRecordedCall;

    const action = await dispatch(
      thunk({
        recordedCallId: recordedCall.id,
        reason,
      })
    );

    setSubmitting(false);

    if (action.meta.requestStatus === "fulfilled") {
      onClose();
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Stack spacing={3}>
        <Typography>
          {recordedCall.retainPermanently
            ? "You’re about to release permanent retention on this call."
            : "You’re about to retain this call permanently."}
        </Typography>

        <FormControl fullWidth required>
          <FormLabel htmlFor="retention-reason">Reason</FormLabel>
          <TextField
            id="retention-reason"
            placeholder="Enter your reason here..."
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            error={error}
            helperText={error ? "Reason is required" : ""}
            multiline
            minRows={4}
            fullWidth
          />
        </FormControl>

        <Button
          type="submit"
          fullWidth
          variant="contained"
          disabled={submitting}
        >
          Submit
        </Button>
      </Stack>
    </form>
  );
};

export default RetentionModalContent;
